export default "__VITE_ASSET__jAkJPsra__"